"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.SUPPORT_PHONE = exports.SUPPORT_EMAIL = exports.PRESS_EMAIL = exports.EmailUs = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _TrackingLink = _interopRequireDefault(require("../TrackingLink"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Spacing = _interopRequireDefault(require("../Spacing"));

/** Contact EarnUp emails */
var SUPPORT_EMAIL = 'mailto:support@earnup.com';
exports.SUPPORT_EMAIL = SUPPORT_EMAIL;
var SUPPORT_PHONE = 'tel:800-209-9700';
exports.SUPPORT_PHONE = SUPPORT_PHONE;
var PRESS_EMAIL = 'mailto:press@earnup.com';
exports.PRESS_EMAIL = PRESS_EMAIL;

var styles = function styles(theme) {
  return (0, _defineProperty2["default"])({
    emailUsContainer: {},
    emailUsBlock: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      paddingBottom: theme.spacing(2)
    },
    emailUsTitle: {
      fontWeight: 800,
      fontSize: '0.85em'
    },
    link: {
      color: theme.palette.primary.main
    }
  }, theme.breakpoints.down('sm'), {
    emailUsContainer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      paddingBottom: theme.spacing(2)
    },
    emailUsContainerMobileNav: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    emailUsBlock: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    }
  });
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var EmailUs = function EmailUs(_ref2) {
  var inMobileNav = _ref2.inMobileNav;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    className: inMobileNav ? classes.emailUsContainerMobileNav : classes.emailUsContainer,
    marginBottom: 4,
    marginTop: 4
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.emailUsBlock
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.emailUsTitle
  }, "CUSTOMER SUPPORT"), /*#__PURE__*/_react["default"].createElement(_TrackingLink["default"], {
    variant: "text",
    className: classes.link,
    to: SUPPORT_PHONE,
    ContainerProps: {
      inline: true
    },
    dataQa: "footer-support-phone"
  }, "800-209-9700"), /*#__PURE__*/_react["default"].createElement(_TrackingLink["default"], {
    variant: "text",
    className: classes.link,
    to: SUPPORT_EMAIL,
    ContainerProps: {
      inline: true
    },
    dataQa: "footer-support-email"
  }, "support@earnup.com")), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.emailUsBlock
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.emailUsTitle
  }, "PRESS INQUIRES"), /*#__PURE__*/_react["default"].createElement(_TrackingLink["default"], {
    variant: "text",
    className: classes.link,
    to: PRESS_EMAIL,
    ContainerProps: {
      inline: true
    },
    dataQa: "footer-press-email"
  }, "press@earnup.com")));
};

exports.EmailUs = EmailUs;
var _default = EmailUs;
exports["default"] = _default;